import React from 'react';
import { Typography } from 'antd';
import { RobotOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ModalHeaderProps {
  contactName: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ contactName }) => (
  <div className="modal-title">
    <div className="title-left">
      <div className="title-left">
        <RobotOutlined className="ai-icon" />
        <Text strong>Sales Assistant AI</Text>
      </div>
      <div className="context-badge">
        Context: {contactName}
      </div>
    </div>
  </div>
);
